import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconAnimatePath: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconAnimatePath"><Path d="M2.5 19.5C2.5 17.3182 3.625 7.5 7 7.5C10.375 7.5 11.5 17.3182 11.5 19.5" stroke="currentColor" strokeLinecap="square"/><Path d="M11.5 19.4998C11.5 18.4553 11.9099 13.6666 15.8431 9.25" stroke="currentColor" strokeLinecap="square"/><Circle cx="18.5" cy="7.5" r="3" stroke="currentColor"/></CentralIconBase>;
});

export default IconAnimatePath;
